import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FolderThemeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FolderTheme",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.24 10.08H15.91a.52.52 0 0 1-.45-.38l-1.2-3.52a3.76 3.76 0 0 0-3.57-2.58H7.31c-1.61 0-3.04 1.03-3.56 2.55L2.2 10.84c-.13.38-.2.78-.21 1.18v12.6c0 2.07 1.68 3.76 3.76 3.76h20.49c2.07 0 3.76-1.68 3.76-3.76v-10.8c0-2.07-1.68-3.76-3.76-3.76Zm-21.7 4.14c-.19-.09-.36-.2-.51-.34-.85-.73-.95-2.01-.21-2.86.73-.85 2.01-.95 2.86-.21.03.02.05.05.08.07l11.46 7.58-2.17 3.34zm13.86 8.45c-.22.33-.66.42-1 .21a.7.7 0 0 1-.32-.46.73.73 0 0 1 .1-.54l1.54-2.39a.731.731 0 0 1 1.23.79l-1.55 2.41zm7.17 3.47h-.07c-.32 0-.63.05-.94.05h-.07c-.68.01-1.35-.04-2.02-.15h-.06c-.37-.06-.74-.15-1.09-.27-2.17-.72-2.34-2.82-.94-4.29s3.44-.49 4.12 1.7c.12.48.36.93.7 1.3.11.11.25.21.39.27.26.08.45.28.51.54.1.38-.14.77-.52.87h-.03v-.02Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M9 29.29H3.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h9.14c.9 0 1.79.37 2.42 1l2.09 2.09c.22.22.5.33.81.33h10.68c1.89 0 3.43 1.54 3.43 3.43v1.14a1.14 1.14 0 1 1-2.28 0V8.71c0-.63-.51-1.14-1.14-1.14H17.76c-.92 0-1.78-.36-2.42-1l-2.09-2.09a1.16 1.16 0 0 0-.81-.33H3.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14H9a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.06 29.29h-3.2c-1.89 0-3.43-1.54-3.43-3.43V13.29c0-1.89 1.54-3.43 3.43-3.43h3.2c1.89 0 3.43 1.54 3.43 3.43v12.57c0 1.89-1.54 3.43-3.43 3.43m-3.2-17.15c-.63 0-1.14.51-1.14 1.14v12.57c0 .63.51 1.14 1.14 1.14h3.2c.63 0 1.14-.51 1.14-1.14V13.28c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M29.16 29.29H18.15a1.14 1.14 0 1 1 0-2.28h11.01c.23 0 .42-.19.42-.42v-3.01a1.14 1.14 0 1 1 2.28 0v3.01c0 1.49-1.21 2.7-2.7 2.7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.38 26.97c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l8.09-8.09c.11-.11.12-.23.12-.29s-.02-.19-.12-.29l-3.29-3.29a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.29 3.29c.51.51.79 1.19.79 1.91s-.28 1.4-.79 1.91l-8.09 8.09c-.22.22-.52.33-.81.33"
      })]
    })
  }));
};
FolderThemeIcon.displayName = 'FolderThemeIcon';